<template>
    <div class="Input Input--radio">
        <label
            :for="name"
            class="Input-labelRadio">
            <input
                @change="onChange"
                type="radio"
                :name="name"
                :checked="checked"
            >
            {{ label }}
        </label>
    </div>
</template>
<script>
export default {
    name: 'HempelRadio',
    props: {
        label: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        checked: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onChange(e) {
            this.$emit('change', {
                value: e.target.value
            })
        }
    }
}
</script>
